import React from 'react';
import { css } from '@emotion/react';
import { useWindowWidth } from '@/hooks/useWindowWidth';

interface HomeIconProps {
  className?: string;
}

const HomeIcon: React.FC<HomeIconProps> = ({ className }) => {
  const { isPC } = useWindowWidth();

  return (
    <div css={container}>
      <div className={`home-icon`}>
        {isPC ? (
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 22.4782C15 21.861 15.2849 21.2784 15.7721 20.8995L22.7721 15.455C23.4943 14.8933 24.5057 14.8933 25.2279 15.455L32.2279 20.8995C32.7151 21.2784 33 21.861 33 22.4782V31.5C33 32.6046 32.1046 33.5 31 33.5H17C15.8954 33.5 15 32.6046 15 31.5V22.4782Z"
              stroke="white"
              strokeWidth="1.5"
            />
            <path
              d="M20.5 29H27.5"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
          >
            <path
              d="M2.5 9.39483C2.5 8.77765 2.78495 8.19504 3.27212 7.81612L8.77212 3.53835C9.49434 2.97662 10.5057 2.97662 11.2279 3.53835L16.7279 7.81612C17.2151 8.19504 17.5 8.77765 17.5 9.39483V16.4167C17.5 17.5212 16.6046 18.4167 15.5 18.4167H4.5C3.39543 18.4167 2.5 17.5212 2.5 16.4167V9.39483Z"
              stroke="white"
              strokeWidth="1.5"
            />
            <path
              d="M7.0835 14.6667H12.9168"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        )}
      </div>
    </div>
  );
};
const container = css`
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
`;

export default HomeIcon;
